<template>
  <div
    :class="
      browserSize.xs === true || browserSize.sm === true
        ? 'methods'
        : 'methods2'
    "
  >
    <v-row>
      <v-col>
        <img
          width="220"
          height="150"
          class="iconMargin"
          src="../assets/narzady-wewn.jpg"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        col-md-12
        class="infText text-center"
        v-if="browserSize.xs === true || browserSize.sm === true"
      >
        <div class="display-1 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
      <v-col col-md-12 class="infText text-center" v-else>
        <div class="display-2 font-weight-black grey--text text-center">
          {{ title }}
        </div>
      </v-col>
    </v-row>

    <v-row>
      <v-col class="col-11">
        <span class="aboutText">
          {{ opis1 }}
        </span>
      </v-col>
    </v-row>

    <p class="paragraph">
      <b>{{ opis2 }}</b>
    </p>
    <li class="paragraph2" v-for="item in list" :key="item.index">
      {{ item }}
    </li>
  </div>
</template>

<script>
export default {
  data() {
    return {
      title: "Fizjoterapia ortopedyczna",
      opis1:
        "Prawidłowe funkcjonowanie narządów wewnętrznych takich jak: żołądek, wątroba czy jelita, ma istotny wpływ na funkcjonowanie i jakość życia człowieka. Nieprawidłowa praca jednego z narządów wewnętrznych może wpływać na zmianę napięć w układzie mięśniowym, więzadłowym, stawowym i powięziowym, a także trawiennym, oddechowym, naczyniowym, nerwowym czy moczowo-płciowym. W trakcie działań terapeutycznych i diagnostycznych leczenie narządów wewnętrznych połączone jest z pracą na powięziach, więzadłach, nerwach oraz naczyniach.",
      opis2:
        "Terapia narządów wewnętrznych obejmuje pracę z zaburzeniami funkcjonalnymi takimi jak wzdęcia, nudności, zaparcia, zespół jelita drażliwego czy refluks. Terapia ta pozwala na:",
      list: [
        "przywrócenie fizjologicznych ruchów tkanek i właściwej funkcji organizmu,",
        "uwolnienie istniejących ograniczeń tkanek takich jak blizny czy zrosty,",
        "regenerację tkanek, ",
        "przywrócenie właściwego krążenia płynów,",
        "poprawę zaopatrzenia komórek w hormony i składniki chemiczne,",
        "wspomożenie procesów trawienia i usuwania z organizmu produktów rozpadu,",
        "normalizację napięcia mięśniowego ,",
        "zredukowanie stanów zapalnych i bólu,",
        "przywrócenie właściwej funkcji zwieraczom i zastawkom organów,",
        "przywrócenie fizjologicznej ruchomości w stawach.",
      ],
    };
  },
  computed: {
    browserSize() {
      return this.$vuetify.breakpoint;
    },
  },
};
</script>

<style lang="scss" scoped>
.methods {
  margin-top: 12vh;
}
.methods2 {
  margin-top: 4vh;
}
.v-application .grey--text {
  color: #414149 !important;
}
.infText {
  margin: auto;
}
.paragraph {
  font-weight: bold;
  margin-top: 10px;
  text-align: left;
  margin-left: 6vw;
  margin-right: 3vw;
}
.paragraph2 {
  text-align: left;
  margin-left: 7vw;
  margin-right: 3vw;
}
.paragraph3 {
  text-align: justify;
  text-align-last: left;
}
.textWhy {
  margin-top: 25px;
  text-align: center;
}
.textWhyPhone {
  margin-top: 25px;
  margin-bottom: 25px;
  text-align: justify;
  text-align-last: left;
}
.aboutText {
  text-align-last: left;
  display: flex;
  align-items: center;
  justify-content: center;
  text-indent: 1.5em;
}
.row {
  display: flex;
  flex-wrap: wrap;
  flex: 1 1 auto;
  margin: auto;
  max-height: 50%;
}
.col {
  text-align: justify;
  text-align-last: center;
}
.col-11 {
  flex: 0 0 91.666667%;
  max-width: 91.666667%;
  align-content: center;
  display: flex;
  margin: auto;
}
</style>